module.exports = __webpack_public_path__ + "img/7.e42f9510.png";